export default {
  showSlide: 'Folie {number} von {count} anzeigen',
};
